import React from "react";
import { css, Global } from "@emotion/react";
import { ThemeProvider } from "@emotion/react";
import Helmet from "react-helmet";
import Footer from "@src/components/Footer";
import Modal from "react-modal";
import normalize from "../styles/normalize";
import theme from "../styles/theme";
import { ModalProvider, ModalRoot } from "@src/components/modals/ModalController";
import { TranslationProvider } from "@src/components/translation/TranslationContext";
import { AppDataContextProvider } from "@src/components/AppDataContext";
import OneTrustScript from "@src/components/partials/shared/OneTrustScript";
import "modern-normalize/modern-normalize.css";
import { generatingFor } from "@src/utils/routes";
import Spacer from "@src/components/Spacer";
import IdeasHeader from "@src/components/ideas/IdeasHeader";
import "extended-proptypes/lib/extend-from-standalone";
import StyledLayoutMain from "@src/layouts/common/StyledLayoutMain";
import { ActivationRedirectionProvider } from "@src/contexts/ActivationRedirectionContext";
import { useTranslationsRepo } from "@src/components/translation/useTranslationsRepo";
import i18next from "i18next";

Modal.setAppElement("#___gatsby");

type BlogLayoutProps = {
  children: any;
  pageContext: any;
};

const IdeasLayout: React.FC<BlogLayoutProps> = ({ children, pageContext }) => {
  const localeRepo = useTranslationsRepo(pageContext.localeStrings);

  const lang = i18next.language;
  generatingFor.locale = lang;

  return (
    <>
      <Helmet htmlAttributes={{ lang }}>
        <link rel="stylesheet" href="https://static.classdojo.com/fonts/DojoText/DojoText.css" />
      </Helmet>
      <OneTrustScript />
      <Global
        styles={css`
          ${normalize};
          #___gatsby,
          #gatsby-focus-wrapper,
          main,
          html,
          body {
            height: 100%;
            margin: 0;
          }

          /* modal transitions:  */
          .ReactModal__Content {
            opacity: 0;
            transform: translate(0, -50%);
            transition: transform 300ms ease-out;
          }

          .ReactModal__Content--after-open {
            opacity: 1;
            transform: translate(0, 0);
          }

          .ReactModal__Content--before-close {
            opacity: 0;
            transform: translate(0, -50%);
          }

          a {
            color: #00aeef;
          }
        `}
      />
      <TranslationProvider localeRepo={localeRepo}>
        <ThemeProvider theme={theme}>
          <AppDataContextProvider>
            <ModalProvider>
              <ActivationRedirectionProvider>
                <ModalRoot />
                <StyledLayoutMain id="main-page-container">
                  {!pageContext.simpleLayout && (
                    <>
                      <IdeasHeader />
                      {/* <Spacer marginTop="87px" height="1px" /> */}
                    </>
                  )}

                  {children}
                  {!pageContext.simpleLayout && <Footer isIdea />}
                </StyledLayoutMain>
              </ActivationRedirectionProvider>
            </ModalProvider>
          </AppDataContextProvider>
        </ThemeProvider>
      </TranslationProvider>
    </>
  );
};

export default IdeasLayout;
